import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {LuBellMinus} from 'react-icons/lu'
import {AppButton} from 'src/components'
import {useNotificationFetcher} from 'src/hooks/useNotificationFetcher'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {notificationSelector, resetSearchParams} from 'src/redux/slices/notificationSlices'
import styled from 'styled-components'

const StyledEmptyList = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  background-color: #fff;
`

export const EmptyListSection = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {isLoading, searchParams} = useAppSelector(notificationSelector)
  const {handleFetchNotifications} = useNotificationFetcher()

  const handleResetFilter = () => {
    dispatch(resetSearchParams())
  }

  useEffect(() => {
    handleFetchNotifications()
  }, [searchParams])

  return (
    <StyledEmptyList>
      <LuBellMinus className='text-secondary' size={80} />
      <div className='fw-bold text-primary'>{t('NotificationPage.EmptyListSection.text')}</div>
      <AppButton
        isLoading={isLoading}
        disabled={isLoading}
        text={t('NotificationPage.EmptyListSection.resetButton')}
        onClick={handleResetFilter}
      />
    </StyledEmptyList>
  )
}
